import { gql } from '../../../apollo/__generated__';

export const CURRENT_EVENT = gql(`
  query CurrentEvent {
    currentEvent {
      id
      name
      type
      description
      lydiaLink
      checkAddress
      maxUsers
      startAt
      endAt
      hasJoined
      waitingListPosition
      hasPaidTicket
      paidTransactionsForOtherUsers {
        id
        user {
          id
          firstname
          lastname
          nickname
          }
      }
      userWhoPaidTicket {
        id
        firstname
        lastname
        nickname
        isMe
      }
      hasPaidBedroom
      hasCaution
      isValidated
      numberOfDays
      isTargetEnabled
      isTinderEnabled
      hasJoinedTinder
      milestones {
        id
        name
        prices {
          day
          value
        }
        startAt
        endAt
        bedroomValue
        noAlcoholDiscount
        isVoucherOnly
      }
      place {
        id
      }
      areBedroomFull
      isFull
      bedroom {
        id
      }
    }
  }
`);
